export default "__VITE_ASSET__FYIkLIYB__"